import { storageRepository } from '../repositories/storage';
import { StorageRepository } from '../repositories/storage/StorageRepository';

class StorageService {
  constructor(private storageRepository: StorageRepository) {
    this.storageRepository = storageRepository;
  }
  async getItem({ key }: { key: string }): Promise<string | null> {
    return this.storageRepository.getItem({ key });
  }
  async setItem({ key, item }: { key: string; item: string }): Promise<void> {
    return this.storageRepository.setItem({ key, item });
  }
  async removeItem({ key }: { key: string }): Promise<void> {
    return this.storageRepository.removeItem({ key });
  }
}

export const storageService = new StorageService(storageRepository);
